import { patchState, signalStore, withMethods, withState } from '@ngrx/signals';
import { initialCandidateDetailsSlice } from './candidate-details.slice';
import { environment } from 'src/environments/environment';
import { CandidateDetails } from '../../models/candidate-details.models';

export const CandidateDetailsStore = signalStore(
    { providedIn: 'root' },
    withState(initialCandidateDetailsSlice),
    withMethods((store) => ({
        updateCandidateDetailsFromData: (data: CandidateDetails) => {
            patchState(store, { ...data });
        },
        updateSelectedSpecialtyId: (specialtyId: number) => {
            patchState(store, { selectedSpecialtyId: specialtyId });
        },
        getState: () => store
    })),
    environment.storeWithDevTools('locums-margin-calculator-candidate-details-store')
);
